import PropTypes from 'prop-types';
import ReactSelect, { components } from 'react-select';
import { injectIntl } from 'react-intl';
import iconCaretExpand from '../../../../icons/caret-expand.svg';
import iconClose from '../../../../icons/close.svg';
import { MATCH_TYPE_IN } from '../../../../constants/filterMatchTypes';
import { FormattedMessage } from 'react-intl';

const selectStyles = {
  control: {
    always: {
      height: '49px',
      borderRadius: '4px',
      shadow: '0',
      alignItems: 'flex-start',
    },
    base: {
      borderColor: '#deeaf4',
    },
    focus: {
      borderColor: '#009dd7',
    },
  },
  basics: {
    color: '#0e2539',
    fontSize: '16px',
    lineHeight: '21px',
  },
};

const SelectFilter = ({ config, onChange, value, intl }) => {
  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <img src={iconCaretExpand} alt='' />
    </components.DropdownIndicator>
  );

  const ClearIndicator = (props) => (
    <components.ClearIndicator {...props} className='icon-close-container'>
      <img src={iconClose} className='icon-close' alt='' />
    </components.ClearIndicator>
  );

  return (
    <div className={`filter ${config.hidden ? 'hidden' : ''}`}>
      <label htmlFor={config.field}>{config.label}</label>
      <ReactSelect
        options={config.options}
        name={config.field}
        components={{ DropdownIndicator, ClearIndicator }}
        noOptionsMessage={() => <FormattedMessage id='No options' />}
        onChange={(selected) => {
          onChange({
            target: {
              name: config.field,
              value: selected === null ? undefined : selected,
            },
          });
        }}
        isClearable={true}
        isMulti={config.matchType === MATCH_TYPE_IN}
        placeholder={intl.formatMessage({
          id: config.placeholder || '— Select —',
        })}
        defaultValue={config.options.find((filter) => filter.value === value)}
        styles={{
          control: (provided, state) => {
            const layoutStyles = selectStyles.control;
            let borderColor;

            if (state.isFocused) {
              borderColor = layoutStyles.focus.borderColor;
            } else {
              borderColor = layoutStyles.base.borderColor;
            }

            let boxShadow;
            if (state.isFocused) {
              boxShadow = `0 0 0 ${layoutStyles.always.shadow} ${layoutStyles.focus.borderColor}`;
            } else {
              boxShadow = `0 0 0 ${layoutStyles.always.shadow} ${layoutStyles.base.borderColor}`;
            }

            return {
              ...provided,
              ...layoutStyles.always,
              borderColor,
              boxShadow,
              '&:hover': {
                borderColor,
              },
              fontSize: selectStyles.basics.fontSize,
            };
          },
          placeholder: () => ({
            color: '#bac3c8',
          }),
          indicatorSeparator: () => ({
            alignSelf: 'stretch',
            backgroundColor: '#deeaf4',
            marginBottom: '0',
            marginTop: '0',
            width: '1px',
            height: '47px',
            boxSizing: 'border-box',
          }),
          indicatorsContainer: () => ({
            color: selectStyles.basics.color,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }),
          dropdownIndicator: () => ({
            color: selectStyles.basics.color,
            padding: '0 11px',
          }),
          option: (provided) => ({
            ...provided,
            color: '#0e2539',
          }),
          valueContainer: (provided) => ({
            ...provided,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            padding: '0 18px',
            overflow: 'auto',
          }),
          singleValue: (provided) => ({
            ...provided,
            maxWidth: 'calc(100% - 60px)',
          }),
        }}
        className='filter-select'
      />
    </div>
  );
};

SelectFilter.propTypes = {
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  intl: PropTypes.object.isRequired,
};
SelectFilter.defaultProps = {
  value: '',
};

export default injectIntl(SelectFilter);
